module.exports = __webpack_public_path__ + "swishbox.png?6717a214dd77f9a218db774425790719";


//////////////////
// WEBPACK FOOTER
// ./src/assets/swishbox.png
// module id = 55
// module chunks = 0